import {
  computed,
  ChangeDetectionStrategy,
  Component,
  input,
  output
} from '@angular/core';
import {
  CardComponent,
  CardContentComponent,
} from '@gains-com/ui-angular';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { PurchaseDialogHeaderComponent } from '../purchase-dialog-header/purchase-dialog-header.component.js';
import { PaymentStatusIndicatorComponent } from '../../payment-status-indicator/payment-status-indicator.component.js';
import { PurchaseAndPaymentUpdateRTM } from '@gains-com/realtime';
import { DecimalPipe } from '../../../../pipes/decimal.pipe.js';
import { PurchaseSelection } from '../../common.js';
import { decimal, PurchaseFailureReason, PurchaseStatus } from '@gains-com/shared';
import { GoldCoinsIconComponent } from '../../../coins/gold-coins-icon.component.js';
import { SweepsCoinsIconComponent } from '../../../coins/sweeps-coins-icon.component.js';
import { SweepsVisibleDirective } from '../../../../directives/sweeps-visible.directive.js';
import { NameMismatchNoticeComponent } from '../name-mismatch-notice/name-mismatch-notice.component.js';

@Component({
  selector: 'app-card-confirm-purchase',
  templateUrl: './card-confirm-purchase.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['../styles.scss', './card-confirm-purchase.component.scss'],
  imports: [
    CardComponent,
    CardContentComponent,
    CurrencyPipe,
    DecimalPipe,
    PurchaseDialogHeaderComponent,
    PaymentStatusIndicatorComponent,
    DatePipe,
    GoldCoinsIconComponent,
    SweepsCoinsIconComponent,
    SweepsVisibleDirective,
    NameMismatchNoticeComponent,
  ],
})
export class CardConfirmPurchaseComponent {
  // Input signals
  step = input<number>();
  package = input.required<PurchaseSelection>();
  purchase = input.required<PurchaseAndPaymentUpdateRTM>();

  // Computed signals
  amount = computed(() => this.package()?.inputAmount?.toNumber() ?? 0);

  goldAmountVM = computed(() =>
    this.purchase().gc_received_scaled
      ? decimal(this.purchase().gc_received_scaled!)
          .div(decimal(10).pow(this.purchase().gc_received_scale_factor!))
          .toNumber()
      : null
  );

  sweepsAmountVM = computed(() =>
    this.purchase().sc_received_scaled
      ? decimal(this.purchase().sc_received_scaled!)
          .div(decimal(10).pow(this.purchase().sc_received_scale_factor!))
          .toNumber()
      : null
  );

  nameMismatch = computed(
    () =>
      this.purchase().purchase_status === PurchaseStatus.Failed &&
      this.purchase().failure_reason === PurchaseFailureReason.NameMismatch
  );

  readonly close = output<'contact-support' | void>();
}
